import { API } from "./API";
export const AlphanumericReportAPI = {
 
    GetSenderList: async (groupId, searchText, isOnLoad) => {

        let data = JSON.stringify({
            requestValue: {
                groupId: groupId,
                searchText : searchText,
                isOnLoad : isOnLoad,
                paging: "0",                
            },
        })
        return await API.post(`AlphanumericReport/GetSenderList`, data);
    },   
    
}